var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-skeleton-loader",class:{ animation: _vm.assignedOptions.animate }},_vm._l((_vm.$options.filters.forceToNestedArray(_vm.content)),function(row,rowIndex){return _c('div',{key:rowIndex,staticClass:"row"},_vm._l((row),function(element,elementIndex){return _c('div',{key:elementIndex,staticClass:"col",style:({
        'flex-grow': (() => {
          if (element.indexOf('box') > -1 || element.indexOf('circle') > -1) {
            return 0;
          } else {
            return 1;
          }
        })()
      })},[(element === 'blank')?[_vm._m(0,true)]:_vm._e(),(element.includes('title'))?[_c('span',{staticClass:"elements"},[_c('span',{staticClass:"element title",style:({
              height: _vm.assignedOptions.defaultSizes.title + 'px',
              borderRadius: _vm.assignedOptions.radius + 'px',
              backgroundColor: _vm.assignedOptions.primaryColor,
              '--secondaryColor': _vm.assignedOptions.secondaryColor,
              '--speed': _vm.assignedOptions.speed,
            })})])]:_vm._e(),(element.includes('text'))?[_c('span',{staticClass:"elements"},_vm._l((_vm.parseTextChildren(element)),function(elementChild,i){return _c('span',{key:i,staticClass:"element text",style:({
              height: _vm.assignedOptions.defaultSizes.text + 'px',
              borderRadius: _vm.assignedOptions.radius + 'px',
              backgroundColor: _vm.assignedOptions.primaryColor,
              '--secondaryColor': _vm.assignedOptions.secondaryColor,
              '--speed': _vm.assignedOptions.speed,
            })})}),0)]:_vm._e(),(element.includes('box'))?[_c('span',{staticClass:"elements"},[_c('span',{staticClass:"element box",style:({
              width: (() => {
                if (!_vm.parseBoxSize(element).includes('/')) {
                  return _vm.parseBoxSize(element).split(':')[1] + 'px';
                }
                if (_vm.parseBoxSize(element).includes('/')) {
                  return _vm.parseBoxSize(element).split(':')[1].split('/')[0] + 'px';
                }
                return _vm.assignedOptions.defaultSizes.box + 'px';
              })(),
              height: (() => {
                if (!_vm.parseBoxSize(element).includes('/')) {
                  return _vm.parseBoxSize(element).split(':')[1] + 'px';
                }
                if (_vm.parseBoxSize(element).includes('/')) {
                  return _vm.parseBoxSize(element).split(':')[1].split('/')[1] + 'px';
                }
                return _vm.assignedOptions.defaultSizes.box + 'px';
              })(),
              borderRadius: _vm.assignedOptions.radius + 'px',
              backgroundColor: _vm.assignedOptions.primaryColor,
              '--secondaryColor': _vm.assignedOptions.secondaryColor,
              '--speed': _vm.assignedOptions.speed,
            })})])]:_vm._e(),(element.includes('circle'))?[_c('span',{staticClass:"elements"},[_c('span',{staticClass:"element circle",style:({
              width: (() => {
                if (!_vm.parseBoxSize(element).includes('/')) {
                  return _vm.parseBoxSize(element).split(':')[1] + 'px';
                }
                if (_vm.parseBoxSize(element).includes('/')) {
                  return _vm.parseBoxSize(element).split(':')[1].split('/')[0] + 'px';
                }
                return _vm.assignedOptions.defaultSizes.circle + 'px';
              })(),
              height: (() => {
                if (!_vm.parseBoxSize(element).includes('/')) {
                  return _vm.parseBoxSize(element).split(':')[1] + 'px';
                }
                if (_vm.parseBoxSize(element).includes('/')) {
                  return _vm.parseBoxSize(element).split(':')[1].split('/')[1] + 'px';
                }
                return _vm.assignedOptions.defaultSizes.circle + 'px';
              })(),
              borderRadius: _vm.assignedOptions.circleRadius + '%',
              backgroundColor: _vm.assignedOptions.primaryColor,
              '--secondaryColor': _vm.assignedOptions.secondaryColor,
              '--speed': _vm.assignedOptions.speed,
            })})])]:_vm._e()],2)}),0)}),0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"elements"},[_c('span',{staticClass:"element blank"})])
}]

export { render, staticRenderFns }